export default function IndexSection() {
  const items = [
    { label: '国产剧', count: '3,280部', icon: 'ri-china-railway-line' },
    { label: '日韩剧', count: '2,150部', icon: 'ri-earth-line' },
    { label: '欧美剧', count: '4,620部', icon: 'ri-global-line' },
    { label: '动漫', count: '5,830部', icon: 'ri-ghost-line' },
    { label: '综艺', count: '1,960部', icon: 'ri-emotion-laugh-line' },
    { label: '纪录片', count: '2,410部', icon: 'ri-camera-lens-line' },
    { label: '电影', count: '8,750部', icon: 'ri-film-line' },
    { label: '少儿', count: '1,340部', icon: 'ri-heart-line' },
  ];

  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            分类索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            八大影视分类，精准找到你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="flex flex-col items-center gap-3 p-6 bg-background-50 rounded-xl border border-background-200/50 cursor-pointer hover:border-primary-500/30 hover:bg-background-200/30 transition-all duration-200 no-underline group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center group-hover:bg-accent-500/20 transition-colors">
                <i className={`${item.icon} text-accent-500 text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-100 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}